export function showMessage(htmlId, identifier, text) {
  return {
    type: 'SHOW_MESSAGE',
    payload: {
      htmlId: htmlId,
      identifier: identifier,
      text: text
    },
  };
}

export function showWarningMessage(htmlId, identifier, text, width, top) {
  return {
    type: 'SHOW_WARNING_MESSAGE',
    payload: {
      htmlId: htmlId,
      identifier: identifier,
      text: text,
      width: width,
      top: top
    },
  };
}

export function closeMessage() {
  return {
    type: 'CLOSE_MESSAGE',
    payload: {},
  };
}

export function addMessage(text) {
  return {
    type: 'ADD_MESSAGE',
    payload: { text: text },
  };
}

export function fileMessage({ item, message, error }) {
  return {
    type: "FILE_MESSAGE",
    payload: {
      fileId: item ? item.fileId : 0,
      message,
      error
    }
  };
}
